import { Theme } from '@infotech-soe/erp-ui-kit';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { Navigate } from 'react-router-dom';

import { AuthResult } from '../../../store/slices/session';
import DataviewPane from '../DataviewPane';
import ApplicationMenu from '../menu/ApplicationMenuContainer';

import Header from './Header';
import { MainViewContainerProps } from './MainViewContainer';
import SystemNotificationList from './SystemNotificationList';

const useStyles = createUseStyles(({ sizes }: Theme) => ({
  container: {
    height: (sysNotificationsNumber: number) =>
      `calc(100vh - ${
        sizes.mainHeader.height +
        sysNotificationsNumber * sizes.systemNotification.height
      }px)`,
    overflowY: 'hidden',
    position: 'relative',
    zIndex: 0,
  },
}));

const MainView = ({
  appName,
  authenticated,
  isShowConfirmation,
  systemNotifications,
  userName,
}: MainViewContainerProps): React.JSX.Element => {
  const classes = useStyles(systemNotifications.length);

  return authenticated === AuthResult.NO ? (
    <Navigate to="/" />
  ) : (
    <>
      <SystemNotificationList notifications={systemNotifications} />
      <Header userName={userName} appName={appName} />
      <div className={classes.container}>
        <DataviewPane isShowConfirmation={isShowConfirmation} />
        <ApplicationMenu />
      </div>
    </>
  );
};

export default MainView;
